import { InfoIcon } from '@/components/icons'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/**
 * Warning next to a published campaign, for example ad sets of AI audiences that were not published or
 * exclusions that were left out. Each kind of warning is on its own line.
 */
const CampaignWarning = ({ message }) => {
    if (!message) return null

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span role="img" aria-label={message} className="tw:shrink-0" data-testid="campaign-warning">
                    <InfoIcon size={18} className="tw:text-yellow-300" />
                </span>
            </TooltipTrigger>
            <TooltipContent className="tw:max-w-80">
                <span className="tw:whitespace-pre-line">{message}</span>
            </TooltipContent>
        </Tooltip>
    )
}

export default CampaignWarning
